// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts"
// @generated from file agentops/v1/agentops.proto (package agentops.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CreateConversationRequest, CreateConversationResponse, GetConversationRequest, GetConversationResponse, InterruptConversationRequest, InterruptConversationResponse, ListConversationsRequest, ListConversationsResponse, SendMessageRequest, SendMessageResponse, SubscribeToConversationRequest, SubscribeToConversationResponse, UpdateConversationRequest, UpdateConversationResponse } from "./agentops_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * AgentOpsService is a service for managing agent conversations. This service is exposed by an agent iself.
 *
 * @generated from service agentops.v1.AgentOpsService
 */
export const AgentOpsService = {
  typeName: "agentops.v1.AgentOpsService",
  methods: {
    /**
     * CreateConversation creates a new conversation.
     *
     * @generated from rpc agentops.v1.AgentOpsService.CreateConversation
     */
    createConversation: {
      name: "CreateConversation",
      I: CreateConversationRequest,
      O: CreateConversationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * UpdateConversation updates an existing conversation.
     *
     * @generated from rpc agentops.v1.AgentOpsService.UpdateConversation
     */
    updateConversation: {
      name: "UpdateConversation",
      I: UpdateConversationRequest,
      O: UpdateConversationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * InterruptConversation interrupts a conversation and stops the agent from executing the current task.
     * Use SendMessage to resume the conversation.
     *
     * @generated from rpc agentops.v1.AgentOpsService.InterruptConversation
     */
    interruptConversation: {
      name: "InterruptConversation",
      I: InterruptConversationRequest,
      O: InterruptConversationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * GetConversation gets a conversation by ID.
     *
     * @generated from rpc agentops.v1.AgentOpsService.GetConversation
     */
    getConversation: {
      name: "GetConversation",
      I: GetConversationRequest,
      O: GetConversationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * ListConversations lists all conversations for the agent.
     *
     * @generated from rpc agentops.v1.AgentOpsService.ListConversations
     */
    listConversations: {
      name: "ListConversations",
      I: ListConversationsRequest,
      O: ListConversationsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SendMessage sends a message to the agent. Depending on your authentication, this might result in a permission denied error.
     *
     * @generated from rpc agentops.v1.AgentOpsService.SendMessage
     */
    sendMessage: {
      name: "SendMessage",
      I: SendMessageRequest,
      O: SendMessageResponse,
      kind: MethodKind.Unary,
    },
    /**
     * SubscribeToConversation subscribes to a conversation. Doing so will stream the conversation to the client, starting from the first message.
     *
     * @generated from rpc agentops.v1.AgentOpsService.SubscribeToConversation
     */
    subscribeToConversation: {
      name: "SubscribeToConversation",
      I: SubscribeToConversationRequest,
      O: SubscribeToConversationResponse,
      kind: MethodKind.ServerStreaming,
    },
  }
} as const;

